import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import {
  fetchEventProductsDone,
  fetchEventProductsError
} from "../../state/events/actions";
import { GET_PRODUCTS_FOR_EVENT } from "../../state/events/constants";

function* fetchEventProducts({ eventId }) {
  try {
    const url = GET_PRODUCTS_FOR_EVENT.replace(":eventId", eventId);
    const result = yield call(Axios.core.get, url);
    yield put(fetchEventProductsDone(result.data));
  } catch (e) {
    yield put(fetchEventProductsError(e));
  }
}

export default fetchEventProducts;
